module.exports = __webpack_public_path__ + "img/1f493.83d1e30.svg";